/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { GetAdminMarketCreationWalletStatusResponse, GetAdminMarketCreationWalletStatusVars } from '../openapi-types.gen.js';

export type { GetAdminMarketCreationWalletStatusResponse, GetAdminMarketCreationWalletStatusVars } from '../openapi-types.gen.js';

export const useGetAdminMarketCreationWalletStatus = createMutationHook<GetAdminMarketCreationWalletStatusVars, GetAdminMarketCreationWalletStatusResponse, unknown>({
  specName: 'useGetAdminMarketCreationWalletStatus',
  path: '/v1/admin/market-creations/wallet-status',
  method: 'POST',
  resolveUrl: (vars: GetAdminMarketCreationWalletStatusVars) => `/v1/admin/market-creations/wallet-status`,
  buildBody: (vars: GetAdminMarketCreationWalletStatusVars) => ({ proof: vars.proof, marketConfigPubkey: vars.marketConfigPubkey }),
  parseResponse: (raw: unknown): GetAdminMarketCreationWalletStatusResponse => raw as GetAdminMarketCreationWalletStatusResponse,
  
  
  
});
